import { render, staticRenderFns } from "./ParticularSend.vue?vue&type=template&id=7d5c102e&scoped=true&"
import script from "./ParticularSend.vue?vue&type=script&lang=js&"
export * from "./ParticularSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5c102e",
  null
  
)

export default component.exports